import LoaderImg from '../../assets/images/LoaderImg.svg';

export const Loader = () => {
  return (
    <div className='loader-container' id='loader'>
      <div className='loader-content'>
        <img src={LoaderImg} className="loader-spin" />
        <div>
          <div className="pepper-title-center">Espera unos segundos...</div>
          <div className="pepper-subtitle">Estamos estableciendo conexión con tu plataforma bancaria.</div>
        </div>
      </div>
    </div>
  )
}
